import axios from "axios";
import authHeader from "@/services/auth-header";

class LogApiCallService {
  get({ from, to, guid, level, userName, fileName }) {
    //from, to, level, userName, fileName, page, pageSize
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/feature/logApiCall?from=${from}&to=${to}&guid=${guid}&level=${level}&userName=${userName}&fileName=${fileName}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  getOne(logGuid) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/feature/logApiCall/One?logGuid=${logGuid}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  getFilterItems() {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/feature/logApiCall/FilterItems`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }
}

export default new LogApiCallService();
